import Vue from 'vue';
import App from './app.view';
import router from './router';
import store from './store';
import i18n from './i18n';

import CustomPage from './components/shared/custom-page/custom-page.component';
import CustomLoadingIndicator from './components/shared/custom-loading-indicator/custom-loading-indicator.component';

Vue.component('CustomPage', CustomPage);
Vue.component('CustomLoadingIndicator', CustomLoadingIndicator);

Vue.config.productionTip = false;

export const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
